import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import {V} from '@/V'

Vue.use(Router)

let router = new Router({
  //mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),
          meta: {
            requiresAuth: true
          },
          beforeEnter (to, from, next) {
            let user = JSON.parse(localStorage.getItem(V.STORE_KEYS.USER))
//            console.log(user)
            if (user.role === 'finamigo') next('/finamigoView')
            else next()
          }
        },
        {
          path: '/activity',
          name: 'Actividades',
          component: () => import(/* webpackChunkName: "demo" */ './views/Activity.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/clients',
          name: 'clientes',
          component: () => import(/* webpackChunkName: "demo" */ './views/Clients.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/newUsers',
          name: 'Nuevos clientes',
          component: () => import(/* webpackChunkName: "demo" */ './views/NewUsers.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/creditReports',
          name: 'Reportes de crédito',
          component: () => import(/* webpackChunkName: "demo" */ './views/MassiveCreditReports.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/projections',
          name: 'Proyecciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/Projections.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/history',
          name: 'Historial',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserHistory.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/accountEditor',
          name: 'Editor de cuentas',
          component: () => import(/* webpackChunkName: "demo" */ './views/MassiveAccountEditor.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commissionEditor',
          name: 'Editor de comisiones',
          component: () => import(/* webpackChunkName: "demo" */ './views/MassiveCommissionEditor.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/finamigoView',
          name: 'Finamigo',
          component: () => import(/* webpackChunkName: "demo" */ './views/FinamigoView.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/balanceVisor',
          name: 'Visor de saldos finamigo',
          component: () => import(/* webpackChunkName: "demo" */ './views/MassiveBalanceVisor.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/massiveLoads',
          name: 'Cargas masivas',
          component: () => import(/* webpackChunkName: "demo" */ './views/MassiveLoads.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/blogEntry',
          name: 'Entrada de blog',
          component: () => import(/* webpackChunkName: "demo" */ './views/BlogEntry.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/blogEntries',
          name: 'Entradas del blog',
          component: () => import(/* webpackChunkName: "demo" */ './views/BlogEntries.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/consultants',
          name: 'Consultores DBMenos',
          component: () => import(/* webpackChunkName: "demo" */ './views/Consultants'),
          meta: {
            requiresAuth: true
          },
          beforeEnter (to, from, next) {
            let user = JSON.parse(localStorage.getItem(V.STORE_KEYS.USER))
//            console.log(user)
            if (user.role === 'admin') {
              next()
            } else {
              next('/dashboard')
            }
          }
        },
        {
          path: '/client',
          name: 'cliente',
          component: () => import(/* webpackChunkName: "demo" */ './views/Client.vue'),
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/leads',
          name: 'leads',
          component: () => import(/* webpackChunkName: "demo" */ './views/Leads.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/icons',
          name: 'icons',
          component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/tables',
          name: 'tables',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/chat',
          component: () => import(/* webpackChunkName: "demo" */ './views/Chat.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue'),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue'),
          meta: {
            requiresAuth: false
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let session = localStorage.getItem("session")
  if (to.meta.requiresAuth && (session === undefined || session === null)) {
    next('/login')
  } else {
    next()
  }
})

export default router
